import { createPaginatedSlice } from '../../../helpers/reduxHelper';

const paginatedAutomation = createPaginatedSlice('paginatedAutomation');

export const paginatedAutomationActions = paginatedAutomation.actions;
export const paginatedAutomationSelector = (state) => state.paginatedAutomation;
export const paginatedAutomationReducer = paginatedAutomation.reducer;
export default paginatedAutomationReducer;

export const paginatedAutomationSelectors = paginatedAutomation.LF.selectors;
